import { downloadCsv } from '@rcm/download-csv';

angular.module('relivConference')
    .controller(
        'relivConferenceTicketsList', [
        '$scope',
        '$window',
        '$location',
        'relivConferenceService',
        'relivConferenceSelectedConference',
        'rcmApiLibMessageService',
        'rcmApiLibMessageAlert',
        'relivConferenceTicketService',
        '$route',
        '$routeParams',
        '$filter',
        function (
            $scope,
            $window,
            $location,
            relivConferenceService,
            relivConferenceSelectedConference,
            rcmApiLibMessageService,
            rcmApiLibMessageAlert,
            relivConferenceTicketService,
            $route,
            $routeParams,
            $filter
        ) {
            var messageNamespace = 'relivConferenceTicketsList';
            $scope.location = $location;
            $scope.resultLimit = '20';

            /**
             * tickets
             * @type {{}}
             */
            $scope.tickets = [];

            /**
             * noTicketsFound
             * @type {boolean}
             */
            $scope.noTicketsFound = true;

            /*
             * ticketQuery
             * @type
             */
            $scope.ticketQuery = $routeParams.search; //Get from URL incase back button was used

            /*
             * conferences
             * @type {{}}
             */
            $scope.conferences = [];

            $scope.noConference = {
                id: 0,
                title: $filter('translate')('Please select conference'),
                available: true,
            };

            /**
             * conferenceSelectedId
             * @type {null}
             */
            $scope.conferenceSelectedId = null;
            $scope.selectorConferenceSelectedId = null;

            $scope.safeApply = function (fn) {
                var phase = this.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    this.$eval(fn);
                } else {
                    this.$apply(fn);
                }
            };

            /**
             * onApiError
             * @param response
             */
            var onApiError = function (response) {
                console.error(response);
                handleMessages(response.messages);
            };

            /**
             *
             * @param response
             * @param index
             */
            var onCheckInSuccess = function (response, index) {
                $scope.tickets[index] = response.data;
            };

            /**
             * onCheckInError
             * @param response
             */
            var onCheckInError = function (response) {
                onApiError(response);
            };

            $scope.handleDownloadCsvClick = () => {
                const filterOutProps = [
                    'dateCreated',
                    'dateModified',
                    '$$hashKey',
                    'ribbons',
                    'features',
                    'isSaved',
                    'activeFeatures',
                    'dateCreatedJS'
                ];
                const tickets = $scope.tickets
                    .filter(ticket => ticket.active === true)
                    .map(ticket => {
                        const returnTicket = Object.assign({}, ticket);
                        filterOutProps.forEach(key => delete returnTicket[key]);
                        return returnTicket;
                    });
                const selectedConference = $scope.conferences
                    .find(conference => conference.id === $scope.selectorConferenceSelectedId);
                const fileName = selectedConference.title + ' active tickets as of '
                    + new Date().toISOString() + '.csv';
                downloadCsv(tickets, fileName);
            };

            /**
             * checkIn
             * @param ticket
             */
            $scope.checkInToggle = function (ticket) {

                var originalValue = ticket.checkedIn;
                ticket.checkedIn = !ticket.checkedIn;
                var confirm = true;

                if (!ticket.checkedIn) {
                    confirm = $window.confirm(
                        'Are you sure you want change the check-in status?'
                    );
                }

                if (!confirm) {
                    ticket.checkedIn = originalValue;
                    return;
                }

                var index = $scope.tickets.indexOf(ticket);
                relivConferenceTicketService.updateTicket(
                    ticket,
                    function (response) {
                        onCheckInSuccess(response, index);
                    },
                    function (response) {
                        ticket.checkedIn = originalValue;
                        onCheckInError(response);
                    }
                );
            };

            var prepareTicket = function (ticket) {
                ticket.dateCreatedJS = new Date(ticket.dateCreatedString);
            };

            /**
             *
             * @param response
             */
            var onGetTicketsSuccess = function (response) {
                $scope.tickets = response.data;
                $scope.tickets.forEach(
                    prepareTicket
                );

                $scope.noTicketsFound = ($scope.tickets.length == 0);
            };

            /**
             *
             * @param response
             * @param status
             */
            var onGetTicketsError = function (response, status) {
                if (status == 401) {
                    $window.location.href = '/login?redirect='
                        + encodeURIComponent(
                            '/conference/check-in#/conference/ticket'
                        );
                }
            };

            /**
             * getTickets
             */
            var getTickets = function (conferenceId) {
                relivConferenceTicketService.getTickets(conferenceId, onGetTicketsSuccess, onGetTicketsError);
            };

            /**
             * setFieldMessages
             * @param messages
             */
            var setFieldMessages = function (messages) {
                $scope.fieldMessages = messages;
            };

            /**
             * handleMessages
             * @param messages
             */
            var handleMessages = function (messages) {

                rcmApiLibMessageService.clearMessages();

                var validatorMessages = rcmApiLibMessageService.getTypeMessages(
                    messages,
                    'validatorMessage',
                    setFieldMessages
                );

                rcmApiLibMessageAlert.displayTypeMessages('validatorMessage', messages);

                $scope.hasMessage = true;
            };

            /**
             *
             * @param conferenceSelectedId
             */
            $scope.setConferenceSelectedId = function (conferenceSelectedId) {
                conferenceSelectedId = Number(conferenceSelectedId);

                if ($scope.conferenceSelectedId == conferenceSelectedId) {
                    return;
                }

                $scope.conferenceSelectedId = conferenceSelectedId;
                $scope.selectorConferenceSelectedId = conferenceSelectedId;
                // console.log(JSON.stringify($scope.selectorConferenceSelectedId), JSON.stringify("0"));

                relivConferenceSelectedConference.setSelected(conferenceSelectedId);

                if (!conferenceSelectedId || conferenceSelectedId < 1) {
                    $scope.tickets = [];
                    return;
                }

                getTickets($scope.conferenceSelectedId);
            };

            /**
             * onApiSuccess
             * @param response
             */
            var onConferenceSuccess = function (response) {
                rcmApiLibMessageService.clearMessages();
                $scope.conferences = response.data;

                if ($scope.conferences.length < 1) {
                    $window.alert('No active conferences available.');
                    return;
                }

                var defaultConferenceId = relivConferenceSelectedConference.getSelected();

                if (!defaultConferenceId) {
                    $scope.setConferenceSelectedId($scope.conferences[0].id);
                    return;
                }

                $scope.setConferenceSelectedId(defaultConferenceId);
            };

            /**
             * getConferences
             */
            var getConferences = function () {
                relivConferenceService.getAllConferences(
                    function (response) {
                        onConferenceSuccess(response);
                    },
                    onApiError
                );
            };

            $scope.goToDetailPage = function (ticketUid) {
                $location.path('/conference/ticket/' + ticketUid);
            };

            //Save search text in URL so it is remembered if the user "back-buttons" here
            $scope.handleSearchQueryChange = function (newTicketQuery) {
                $route.updateParams({ search: newTicketQuery });
            };

            var init = function () {
                getConferences();
            };

            init();
        },
    ]
    )
    .filter(
        'conferenceListFilter', function () {

            var compareStr = function (stra, preLowerCasedStrB) {
                return String(stra).toLowerCase().indexOf(preLowerCasedStrB) !== -1;
            };

            return function (input, query) {
                if (!query) {
                    return input;
                }

                query = query.toLowerCase();
                var result = [];
                angular.forEach(
                    input,
                    function (ticket) {
                        var firstLastName = ticket.firstName + ' ' + ticket.lastName;
                        var ownerFirstLastName = ticket.ownerFirstName + ' ' + ticket.ownerLastName;
                        if (compareStr(
                            ticket.ownerRcn,
                            query
                        ) || compareStr(ticket.skuNumber, query) ||
                            compareStr(ticket.orderNumber, query) || compareStr(
                                ticket.displayRcn,
                                query
                            ) ||
                            (compareStr(ticket.displayName, query)) || compareStr(
                                firstLastName,
                                query
                            ) ||
                            compareStr(ownerFirstLastName, query)) {
                            result.push(ticket);
                            return;
                        }
                        var feature;
                        var len = ticket.features.length;
                        for (var i = 0; i < len; i++) {
                            feature = ticket.features[i];

                            if (compareStr(feature.orderNumber, query)) {
                                result.push(ticket);
                                return;
                            }
                        }
                    }
                );

                return result;
            };
        }
    );
